<!--
Created on 2021-04-20
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-20
-->
<template>
<div id="page">
    
    <!-- header and footer bar go here-->
    <div class="header header-fixed header-auto-show header-logo-app">
        <a href="#" data-back-button class="header-title header-subtitle">Back</a>
        <a href="#" data-back-button class="header-icon header-icon-1"><i class="fas fa-arrow-left"></i></a>
        <a href="#" data-toggle-theme class="header-icon header-icon-3 show-on-theme-dark"><i class="fas fa-sun"></i></a>
        <a href="#" data-toggle-theme class="header-icon header-icon-3 show-on-theme-light"><i class="fas fa-moon"></i></a>
        <a href="#" data-menu="menu-main" class="header-icon header-icon-2"><i class="fas fa-bars"></i></a>
    </div>

    <div class="page-content pb-0">
        <div class="page-title page-title-small">
            <h2><a href="#" data-back-button><i class="fa fa-arrow-left"></i></a>Objednávka</h2>
            <a href="#" data-menu="menu-main" class="bg-fade-highlight-light shadow-xl preload-img" data-src="images/avatars/5s.png"></a>
        </div>
        <div class="card header-card shape-rounded" data-card-height="150">
            <div class="card-overlay bg-highlight opacity-95"></div>
            <div class="card-overlay dark-mode-tint"></div>
            <div class="card-bg preload-img" data-src="images/pictures/20s.jpg"></div>
        </div>

        <!-- name card -->
        <div class="card card-style">
          <div class="content">
            <div class="d-flex mb-2">
              <div>
                <a href="#" data-menu="menu-success"><i data-feather="edit" data-feather-line="1" data-feather-size="30" data-feather-color="blue-dark" data-feather-bg="blue-fade-light" class="m-auto"></i></a>
              </div>
              <div>
                <h2 class="mb-0 pt-1" style="padding-left: 0.5rem;">Nová objednávka</h2>
              </div>
            </div>
            <p class="mb-2">
              Ak je zapnuté automatické odoslanie, bude objednávka hneď po uzavretí odoslaná na servery.
            </p>
            <div class="d-flex no-effect mb-2" 
                  data-trigger-switch="toggle-id-1" 
                  data-bs-toggle="collapse" 
                  href="#" 
                  role="button" 
                  aria-expanded="false" 
                  aria-controls="collapseExample1">
                <div class="pt-2 mt-1">
                  <p>Po uzavretí odoslať automaticky</p>
                </div>
                <div class="ms-auto me-4 pe-2">
                    <div class="custom-control ios-switch" style="margin-top: 12px !important;">
                        <input type="checkbox" class="ios-input" id="toggle-id-1" checked="true">
                        <label class="custom-control-label" for="toggle-id-1"></label>
                    </div>
                </div>
            </div>

            <div class="input-style has-borders input-style-always-active no-icon mb-0">
              <label for="form5" class="color-black-dark font-500">Typ</label>
              <select id="form5" class="bg-white">
                  <option value="1" selected>Objednávka</option>
                  <option value="2">Návšteva</option>
                  <option value="2">Výdajka</option>
              </select>
              <span><i class="fa fa-chevron-down"></i></span>
              <em></em>
            </div>
            <div class="d-flex no-effect mb-2 mt-n2" 
                  data-trigger-switch="toggle-id-2" 
                  data-bs-toggle="collapse" 
                  href="#" 
                  role="button" 
                  aria-expanded="false" 
                  aria-controls="collapseExample2">
                <div class="pt-2 mt-1">
                  <p>Telefonická objednávka</p>
                </div>
                <div class="ms-auto me-4 pe-2">
                    <div class="custom-control ios-switch" style="margin-top: 12px !important;">
                        <input type="checkbox" class="ios-input" id="toggle-id-2">
                        <label class="custom-control-label" for="toggle-id-2"></label>
                    </div>
                </div>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="number" class="form-control validate-text bg-white" id="form3" placeholder="Zľava na faktúru" value="0">
              <label for="form3" class="grey-light">Zľava na faktúru</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em>(povinné)</em>
            </div>
            <div data-menu="menu-dist-select" class="input-style has-borders input-style-always-active no-icon mb-4 pointer">
              <label for="form5" class="color-black-dark font-500">Distribútor</label>
              <input type="text" class="form-control validate-text bg-white pointer" id="form5" readonly="true">
              <span><i class="fa fa-chevron-down"></i></span>
              <em></em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active" style="margin-bottom: 0px !important;">
              <textarea id="form7" class="mb-0"></textarea>
              <label for="form7" class="grey-light">Poznámka</label>
            </div>
          </div>
        </div>

        <!-- address card -->
        <div class="card card-style">
          <div class="content">
            <h3 class="mb-2">Zákazník</h3>
            <p>
              Tu môžete vybrať zákazníka, pre ktorého je objednávka.
            </p>
            <div data-menu="menu-town-select" class="input-style has-borders input-style-always-active no-icon mb-4 pointer">
              <label for="form5" class="color-black-dark font-500">Zákazník</label>
              <input type="text" class="form-control validate-text bg-white pointer" id="form5" readonly="true">
              <span><i class="fa fa-chevron-down"></i></span>
              <em></em>
            </div>
            <div class="row mb-0">
              <div class="col-3"><p class="font-500 color-theme">Číslo</p></div>
              <div class="col-9"><p class="color-black-light">65465046</p></div>
            </div>
            <div class="row mb-0">
              <div class="col-3"><p class="font-500 color-theme">PZS kód</p></div>
              <div class="col-9"><p class="color-black-light">P654650460654</p></div>
            </div>
            <div class="row mb-0">
              <div class="col-3"><p class="font-500 color-theme">Adresa</p></div>
              <div class="col-9"><p class="color-black-light">Hlavná 212/200<br>Viničné, 900 23</p></div>
            </div>
            <div class="row mb-0">
              <div class="col-3"><p class="font-500 color-theme">Kontakt</p></div>
              <div class="col-9">
                <p class="color-black-light">
                  Mgr. Mária Zajíčková<br>
                  <a href="phone:+421950790000" class="external-link" target="_blank">+421950790000</a><br>
                  <a href="mailto:lekaren@trinitas.sk" class="external-link" target="_blank">lekaren@trinitas.sk</a><br>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- address card -->
        <div class="card card-style">
          <div class="content">
            <h3 class="mb-2">Tovar</h3>
            <p>
              Tu môžete pridávať a odoberať samotný tovar objednávky.
            </p>
            <div class="row text-center">
              <h4>TBD</h4>
            </div>
          </div>
        </div>

        <div class="card mt-4">
          <div class="card-body py-4">
              <h2 class="color-white text-center">Súhrn objednávky</h2>
              <p class="color-white boxed-text-xl mb-2">
                  Po stlačení tlačítka "objednať", bude objednávka vytvorená a zaradená na synchronizáciu a poslanie na servery Dr Theiss.
              </p>
              <div class="card card-style mx-0">
                  <div class="content">
                      <div class="row mb-0">
                          <div class="col-6 text-start"><h6 class="font-600">Celkom</h6></div>
                          <div class="col-6 text-end"><h6 class="font-600">1.998,98 €</h6></div>
                          <div class="col-6 text-start"><h6 class="font-600">DPH</h6></div>
                          <div class="col-6 text-end"><h6 class="font-600">20,00 €</h6></div>
                          <div class="col-6 text-start"><h6 class="font-600">Doprava</h6></div>
                          <div class="col-6 text-end"><h6 class="font-600 color-green-dark">0 €</h6></div>
                          <div class="col-12"><div class="divider mt-3"></div></div>
                          <div class="col-6 text-start"><h4>K úhrade</h4></div>
                          <div class="col-6 text-end"><h4>2.018,98 €</h4></div>
                      </div>

                      <a href="#" class="btn btn-full btn-m rounded-sm bg-highlight font-800 text-uppercase mt-4">objednať</a>

                  </div>
              </div>
          </div>
          <div class="card-overlay bg-highlight opacity-95"></div>
          <div class="card-overlay dark-mode-tint"></div>
      </div>

        <!-- back to top -->
        <div class="content mt-5 mb-5">
          <a href="#" class="back-to-top-badge bg-highlight shadow-xl"><i class="fa fa-caret-up"></i><span>Back to Top</span></a>
        </div>
        <!-- footer and footer card-->
    </div>    
    <!-- end of page content-->
    
    <main-menu />

    <!-- modal save success -->
    <div id="menu-success" class="menu menu-box-modal rounded-m" 
         data-menu-height="230" 
         data-menu-width="310">
        <h1 class="text-center mt-3 pt-1"><i class="fa fa-3x fa-check-circle color-green-dark shadow-xl rounded-circle"></i></h1>
        <h1 class="text-center mt-3 font-700">Uložené</h1>
        <p class="boxed-text-l">
          Dáta boli užložené<br>a sú označené na synchronizáciu.
        </p>
    </div>

    <!-- modal distributor select -->
    <div id="menu-dist-select" class="menu menu-box-modal rounded-m p-3" 
        data-menu-height="340" 
        data-menu-width="310">
        <h1 class="text-center font-700">Vyber distribútora</h1>
        <div data-menu="menu-dist-select" class="input-style has-borders input-style-always-active no-icon mb-4">
          <label for="form5" class="color-black-dark font-500">Filter</label>
          <input type="text" class="form-control validate-text bg-white" id="form5">
          <span><i class="fa fa-search"></i></span>
          <span style="display: none"><i class="fa fa-times"></i></span>
          <em></em>
        </div>
        <div style="overflow-x: none; overflow-y: scroll; max-height: 235px;">
          <div class="close-menu">
            <div class="divider mt-1 mb-1"></div>
            <div class="p-2">MED-ART</div>
          </div>
          <div class="close-menu">
            <div class="divider mt-1 mb-1"></div>
            <div class="p-2">PHOENIX</div>
          </div>
          <div class="close-menu">
            <div class="divider mt-1 mb-1"></div>
            <div class="p-2">UNIMED</div>
          </div>
          <div class="close-menu">
            <div class="divider mt-1 mb-1"></div>
            <div class="p-2">UNIPHARMA</div>
          </div>
        </div>
    </div>
  
    <!-- modal town select -->
    <div id="menu-town-select" class="menu menu-box-modal rounded-m p-3" 
      data-menu-height="380" 
      data-menu-width="310">
      <h1 class="text-center font-700">Vyber mesto</h1>
      <div data-menu="menu-town-select" class="input-style has-borders input-style-always-active no-icon mb-4">
        <label for="form5" class="color-black-dark font-500">Filter</label>
        <input type="text" class="form-control validate-text bg-white" id="form5">
        <span><i class="fa fa-search"></i></span>
        <span style="display: none"><i class="fa fa-times"></i></span>
        <em></em>
      </div>
      <div style="overflow-x: none; overflow-y: scroll; max-height: 225px;">
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Všetky</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bratislava</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bernolákovo</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Adamovo</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bratislava</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bernolákovo</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Adamovo</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bratislava</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bernolákovo</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Adamovo</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bratislava</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bernolákovo</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Adamovo</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bratislava</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bernolákovo</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Adamovo</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bratislava</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bernolákovo</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Adamovo</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bratislava</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Bernolákovo</div>
        </div>
        <div>
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Adamovo</div>
        </div>
      </div>
    </div>    

    <!-- modal customer select -->
    <div id="menu-cust-select" class="menu menu-box-modal rounded-m p-3" 
      data-menu-height="390" 
      data-menu-width="310">
      <h1 class="text-center font-700">Vyber zákazníka</h1>
      <div data-menu="menu-town-select" class="input-style has-borders input-style-always-active no-icon mb-4">
        <label for="form5" class="color-black-dark font-500">Filter</label>
        <input type="text" class="form-control validate-text bg-white" id="form5">
        <span><i class="fa fa-search"></i></span>
        <span style="display: none"><i class="fa fa-times"></i></span>
        <em></em>
      </div>
      <div style="overflow-x: none; overflow-y: scroll; max-height: 225px;">
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Vilten sro</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Lekaren Drakula</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Althaeo a.s.</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Vilten sro</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Lekaren Drakula</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Althaeo a.s.</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Vilten sro</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Lekaren Drakula</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Althaeo a.s.</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Vilten sro</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Lekaren Drakula</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Althaeo a.s.</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Vilten sro</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Lekaren Drakula</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Althaeo a.s.</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Vilten sro</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Lekaren Drakula</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Althaeo a.s.</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Vilten sro</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Lekaren Drakula</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Althaeo a.s.</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Vilten sro</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Lekaren Drakula</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div data-menu="menu-cust-select" class="p-2">Althaeo a.s.</div>
        </div>
      </div>
      <div data-menu="menu-town-select" class="mt-2 font-10 color-blue-dark"><i class="fa fa-arrow-left color-blue-dark"></i> Naspäť na výber mesta</div>
    </div>    

    <!-- modal error -->
    <div id="menu-error" class="menu menu-box-modal rounded-m" 
         data-menu-height="400"
         data-menu-width="310">
        <h1 class="text-center mt-3 pt-1"><i class="fa fa-3x fa-times color-red-dark"></i></h1>
        <h1 class="text-center mt-3 font-700">Chyba!</h1>
        <p id="error_text" class="boxed-text-l" style="overflow: scroll; height: 140px;">
          javax.servlet.ServletException: Something bad happened
          at com.example.myproject.OpenSessionInViewFilter.doFilter(OpenSessionInViewFilter.java:60)
          at org.mortbay.jetty.servlet.ServletHandler$CachedChain.doFilter(ServletHandler.java:1157)
          at com.example.myproject.ExceptionHandlerFilter.doFilter(ExceptionHandlerFilter.java:28)
          at org.mortbay.jetty.servlet.ServletHandler$CachedChain.doFilter(ServletHandler.java:1157)
          at com.example.myproject.OutputBufferFilter.doFilter(OutputBufferFilter.java:33)
          at org.mortbay.jetty.servlet.ServletHandler$CachedChain.doFilter(ServletHandler.java:1157)
          at org.mortbay.jetty.servlet.ServletHandler.handle(ServletHandler.java:388)
          at org.mortbay.jetty.security.SecurityHandler.handle(SecurityHandler.java:216)
          at org.mortbay.jetty.servlet.SessionHandler.handle(SessionHandler.java:182)
          at org.mortbay.jetty.handler.ContextHandler.handle(ContextHandler.java:765)
          at org.mortbay.jetty.webapp.WebAppContext.handle(WebAppContext.java:418)
          at org.mortbay.jetty.handler.HandlerWrapper.handle(HandlerWrapper.java:152)
          at org.mortbay.jetty.Server.handle(Server.java:326)
          at org.mortbay.jetty.HttpConnection.handleRequest(HttpConnection.java:542)
          at org.mortbay.jetty.HttpConnection$RequestHandler.content(HttpConnection.java:943)
          at org.mortbay.jetty.HttpParser.parseNext(HttpParser.java:756)
          at org.mortbay.jetty.HttpParser.parseAvailable(HttpParser.java:218)
          at org.mortbay.jetty.HttpConnection.handle(HttpConnection.java:404)
          at org.mortbay.jetty.bio.SocketConnector$Connection.run(SocketConnector.java:228)
          at org.mortbay.thread.QueuedThreadPool$PoolThread.run(QueuedThreadPool.java:582)
      Caused by: com.example.myproject.MyProjectServletException
          at com.example.myproject.MyServlet.doPost(MyServlet.java:169)
          at javax.servlet.http.HttpServlet.service(HttpServlet.java:727)
          at javax.servlet.http.HttpServlet.service(HttpServlet.java:820)
          at org.mortbay.jetty.servlet.ServletHolder.handle(ServletHolder.java:511)
          at org.mortbay.jetty.servlet.ServletHandler$CachedChain.doFilter(ServletHandler.java:1166)
          at com.example.myproject.OpenSessionInViewFilter.doFilter(OpenSessionInViewFilter.java:30)
          ... 27 more
      Caused by: org.hibernate.exception.ConstraintViolationException: could not insert: [com.example.myproject.MyEntity]
          at org.hibernate.exception.SQLStateConverter.convert(SQLStateConverter.java:96)
          at org.hibernate.exception.JDBCExceptionHelper.convert(JDBCExceptionHelper.java:66)
          at org.hibernate.id.insert.AbstractSelectingDelegate.performInsert(AbstractSelectingDelegate.java:64)
          at org.hibernate.persister.entity.AbstractEntityPersister.insert(AbstractEntityPersister.java:2329)
          at org.hibernate.persister.entity.AbstractEntityPersister.insert(AbstractEntityPersister.java:2822)
          at org.hibernate.action.EntityIdentityInsertAction.execute(EntityIdentityInsertAction.java:71)
          at org.hibernate.engine.ActionQueue.execute(ActionQueue.java:268)
          at org.hibernate.event.def.AbstractSaveEventListener.performSaveOrReplicate(AbstractSaveEventListener.java:321)
          at org.hibernate.event.def.AbstractSaveEventListener.performSave(AbstractSaveEventListener.java:204)
          at org.hibernate.event.def.AbstractSaveEventListener.saveWithGeneratedId(AbstractSaveEventListener.java:130)
          at org.hibernate.event.def.DefaultSaveOrUpdateEventListener.saveWithGeneratedOrRequestedId(DefaultSaveOrUpdateEventListener.java:210)
          at org.hibernate.event.def.DefaultSaveEventListener.saveWithGeneratedOrRequestedId(DefaultSaveEventListener.java:56)
          at org.hibernate.event.def.DefaultSaveOrUpdateEventListener.entityIsTransient(DefaultSaveOrUpdateEventListener.java:195)
          at org.hibernate.event.def.DefaultSaveEventListener.performSaveOrUpdate(DefaultSaveEventListener.java:50)
          at org.hibernate.event.def.DefaultSaveOrUpdateEventListener.onSaveOrUpdate(DefaultSaveOrUpdateEventListener.java:93)
          at org.hibernate.impl.SessionImpl.fireSave(SessionImpl.java:705)
          at org.hibernate.impl.SessionImpl.save(SessionImpl.java:693)
          at org.hibernate.impl.SessionImpl.save(SessionImpl.java:689)
          at sun.reflect.GeneratedMethodAccessor5.invoke(Unknown Source)
          at sun.reflect.DelegatingMethodAccessorImpl.invoke(DelegatingMethodAccessorImpl.java:25)
          at java.lang.reflect.Method.invoke(Method.java:597)
          at org.hibernate.context.ThreadLocalSessionContext$TransactionProtectionWrapper.invoke(ThreadLocalSessionContext.java:344)
          ... 32 more
      Caused by: java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
          at org.hsqldb.jdbc.Util.throwError(Unknown Source)
          at org.hsqldb.jdbc.jdbcPreparedStatement.executeUpdate(Unknown Source)
          at com.mchange.v2.c3p0.impl.NewProxyPreparedStatement.executeUpdate(NewProxyPreparedStatement.java:105)
          at org.hibernate.id.insert.AbstractSelectingDelegate.performInsert(AbstractSelectingDelegate.java:57)
          ... 54 more
        </p>
        <a href="#" class="close-menu btn btn-m btn-center-m button-s shadow-l rounded-s text-uppercase font-900 bg-red-light" onclick="copy_data(error_text)">KOPÍROVAŤ</a>
    </div>   
    <!-- menu pin warning -->
    <div id="menu-pin-warning" class="menu menu-box-modal rounded-m" 
         data-menu-height="310"
         data-menu-width="310">
      <h1 class="text-center mt-3 pt-1"><i class="fa fa-3x fa-times color-red-dark"></i></h1>
      <h1 class="text-center mt-3 font-700">Nesprávny PIN!</h1>
      <p id="error_text" class="boxed-text-l">
        Zadaný PIN je nesprávny. Prosím, zopakujte proces ešte raz.
      </p>
      <a href="#" class="close-menu btn btn-m btn-center-m button-s shadow-l rounded-s text-uppercase font-900 bg-red-light">OPAKOVAŤ</a>
    </div>   
    
</div>    
</template>

<script>
import MainMenu from '@/components/menus/MainMenu'

export default {
  name: 'OrderDetail',
  components: {
    MainMenu,
  },
  setup() {
    return {

    }
  },
  mounted() {
    setTimeout(() => {
      document.init_event()
    })
  },
}
</script>